import type { MaintenanceSchedule } from "@fleetlease/shared";
import { useList } from "./data";
import { PageHeader, Table } from "./ui";
import { TableSkeleton } from "./ui";

export function Maintenance() {
  const q = useList<MaintenanceSchedule>("maintenance", "/maintenance");
  return (
    <div className="space-y-4">
      <PageHeader title="Maintenance due" />
      {q.isPending ? <TableSkeleton cols={4} /> : (
        <Table<MaintenanceSchedule>
          rows={q.data?.items ?? []}
          empty="Nothing coming due."
          columns={[
            { header: "Service", cell: (m) => m.serviceType },
            { header: "Next due", cell: (m) => m.nextDueDate ?? "—" },
            { header: "Next odometer", cell: (m) => m.nextDueOdometer?.toLocaleString() ?? "—" },
            { header: "Every", cell: (m) => [m.everyMiles ? `${m.everyMiles} mi` : null, m.everyMonths ? `${m.everyMonths} mo` : null].filter(Boolean).join(" / ") },
          ]}
        />
      )}
    </div>
  );
}
